<template>
	<div class="vx-row">
		<div
			id="optimization-download-content"
			class="vx-col w-full vs-con-loading__container"
			:class="maximize ? 'md:w-4/4' : 'md:w-3/5'"
		>
			<vx-card no-shadow card-border>
				<vs-sidebar
					v-if="isSidebarAddActive"
					parent="body"
					click-not-close
					position-right
					default-index="1"
					color="primary"
					class="add-new-data-sidebar items-no-padding"
					v-model="isSidebarAddActive"
				>
					<div class="flex items-center justify-between px-6 p-4" style="background: #eee">
						<h4>{{ $t("Add") + " " + $t("VisitPoint") }}</h4>
						<feather-icon
							icon="XIcon"
							@click.stop="isSidebarAddActive = false"
							class="cursor-pointer"
						></feather-icon>
					</div>
					<vue-perfect-scrollbar class="scroll-area--form" :settings="settingsForm">
						<visit-point-create
							:data="{}"
							:activeTabProp="activeTab"
							@addMarkerEmit="addMarker"
							@closeSidebarEmit="closeSidebar()"
						/>
					</vue-perfect-scrollbar>
				</vs-sidebar>
				<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner" color="success">
					<vs-tab :label="$t('PickUpService')" icon-pack="feather" icon="icon-truck">
						<div class="flex justify-between items-center pr-1">
							<vs-navbar-title class="float-right">
								<span class="text-primary"
									>{{ $t("VisitPoints.VisitingPointsSelected") + ":" }}
									{{ visit_point_selected_pickup ? visit_point_selected_pickup.length : 0 }}</span
								>
							</vs-navbar-title>
							<div class="flex justify-center items-center">
								<!-- Warning Icon for Discarded Items -->
								<vs-button
									v-if="discardedItemsList.length > 0"
									color="warning"
									type="filled"
									class="mr-2"
									icon-pack="feather"
									:icon="'icon-alert-triangle'"
									:title="$t('Frequency.DiscardedItems.Title')"
									@click="activeDiscardedItemsPrompt = true"
								/>
								<vs-button
									v-if="visit_point_selected_pickup.length > 0"
									class="mr-2"
									type="filled"
									icon-pack="feather"
									:title="$t('UploadFiles.Download') + ' ' + $t('VisitPoints.VisitingPointsSelected')"
									:icon="'icon-download'"
									@click.prevent="activeDownload()"
								></vs-button>
								<vs-button
									v-if="maximize"
									class="mr-2"
									type="filled"
									icon-pack="feather"
									:title="$t('Routing.Map.ShowMap')"
									:icon="'icon-map'"
									@click.prevent="handleMaximize"
								></vs-button>
								<vs-button
									v-if="1 === 2"
									class="mr-2"
									type="filled"
									icon-pack="feather"
									icon="icon-repeat"
									:title="$t('GenerationOfRepetitions')"
									@click.prevent="generateRepeatMounted = true"
								></vs-button>
								<vs-button
									v-if="visit_point_selected_pickup.length > 0"
									class="mr-2"
									type="filled"
									icon-pack="feather"
									:title="isExpandedPickup ? $t('CollapseEverything') : $t('ExpandAll')"
									:icon="isExpandedPickup ? 'icon-minimize-2' : 'icon-maximize-2'"
									@click.prevent="toggleAllPickup"
								></vs-button>
								<vs-dropdown
									vs-trigger-click
									class="ml-auto cursor-pointer"
									:title="$t('Routing.Buttons.AddVisitPoint')"
								>
									<vs-button color="primary" type="filled" icon="icon-plus" icon-pack="feather" />
									<vs-dropdown-menu :style="{width: windowWidth > 620 ? '20%' : '50%'}">
										<h4 class="p-4">{{ $t("Routing.Title.VisitPoints") }}</h4>
										<vs-dropdown-item>
											<div
												class="flex items-center"
												:title="$t('MODULE_ROLE.Add') + ' ' + $t('VisitPoint')"
												@click.prevent="showSidebar()"
											>
												<feather-icon
													icon="PlusSquareIcon"
													class="inline-block mr-2 color-logo"
													svgClasses="w-5 h-5"
												/>
												<span>{{ $t("CompanyModule.Add") }}</span>
											</div>
										</vs-dropdown-item>
										<vs-dropdown-group :vs-label="$t('Select')">
											<vs-dropdown-item>
												<div
													class="flex items-center"
													:title="$t('VisitPoints.AssignVisitPointToltip')"
													@click.prevent="visitPointMounted = true"
												>
													<img
														src="@/assets/images/logo/serviroutes.svg"
														style="width: 21px; height: 21px; margin-right: 1px"
														alt=""
													/>
													<span>{{ "Serviroutes" }}</span>
												</div>
											</vs-dropdown-item>
											<vs-dropdown-item>
												<div
													class="flex items-center"
													:title="$t('VisitPoints.AssignVisitPointToltip')"
													@click.prevent="visitPointMountedDatarutas = true"
												>
													<img
														src="@/assets/images/logo/datarutas.svg"
														style="width: 17px; height: 17px; margin-right: 4px"
														alt=""
													/>
													<span>{{ "Datarutas" }}</span>
												</div>
											</vs-dropdown-item>
										</vs-dropdown-group>
										<vs-dropdown-group :vs-label="$t('Upload') + ' ' + $t('UploadFiles.File')">
											<vs-dropdown-item>
												<div
													class="flex items-center"
													@click.prevent="uploadFileMounted = true"
												>
													<feather-icon
														icon="FilePlusIcon"
														class="inline-block mr-2 color-logo"
														svgClasses="w-5 h-5"
													/>
													<span>{{ $t("Routing.Buttons.AddVisitPoint") }}</span>
												</div>
											</vs-dropdown-item>
											<vs-dropdown-item
												:disabled="visit_point_selected_pickup.length > 0 ? false : true"
											>
												<div
													class="flex items-center"
													:title="$t('UpdatingVisitPointsByUploadingFiles')"
													@click.prevent="uploadFileUpdateMounted = true"
												>
													<feather-icon
														icon="EditIcon"
														class="inline-block mr-2 color-logo"
														svgClasses="w-5 h-5"
													/>
													<span>{{ $t("VisitPoints.UpdatePointofVisit") }}</span>
												</div>
											</vs-dropdown-item>
										</vs-dropdown-group>
									</vs-dropdown-menu>
								</vs-dropdown>
							</div>
						</div>
						<div v-if="visit_point_selected_pickup.length > 0" class="vx-col w-full lg:block mt-2 pr-1">
							<div class="flex items-center justify-end">
								<template>
									<vs-dropdown vs-trigger-click class="cursor-pointer">
										<div
											class="p-3 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
										>
											<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
											<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
										</div>
										<vs-dropdown-menu>
											<vs-dropdown-item @click="setSearchField('Identification')">
												<span>{{ $t("ResourceModule.Table.Identification") }}</span>
											</vs-dropdown-item>
											<vs-dropdown-item @click="setSearchField('GroupSearch')">
												<span>{{ $t("GroupSearch") }}</span>
											</vs-dropdown-item>
										</vs-dropdown-menu>
									</vs-dropdown>
								</template>
								<vs-input
									v-model="searchQueryPickup"
									icon="icon-search"
									icon-pack="feather"
									class="w-full md:w-1/2"
									:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
								/>
							</div>
						</div>
						<vue-perfect-scrollbar class="scroll-area" :settings="settings">
							<ListSelectedVisitPointsItemPickup
								ref="ListSelectedVisitPointsItemPickup"
								:visit_point_selected="getVisitPointPickupList"
								:activeTabProp="activeTab"
								:markerArray="markerArrayProps"
								:searchQueryPickup="searchQueryPickup"
								@removeMarkerEmit="removeMarker"
								@startBounceAnimation="startBounceAnimation"
								@closeAnimation="closeAnimation"
								@getExpanded="getExpandedPickup"
							></ListSelectedVisitPointsItemPickup>
						</vue-perfect-scrollbar>
					</vs-tab>
					<vs-tab :label="$t('DeliveryService')" icon-pack="feather" icon="icon-package">
						<div class="flex justify-between items-center">
							<vs-navbar-title class="float-right">
								<span class="text-primary"
									>{{ $t("VisitPoints.VisitingPointsSelected") + ":" }}
									{{
										visit_point_selected_delivery
											? visit_point_selected_delivery.length
											: visit_point_selected_pickup
											? visit_point_selected_pickup.length
											: 0
									}}</span
								>
							</vs-navbar-title>
							<div class="flex justify-center items-center">
								<!-- Warning Icon for Discarded Items -->
								<vs-button
									v-if="discardedItemsList.length > 0"
									color="warning"
									type="filled"
									class="mr-2"
									icon-pack="feather"
									:icon="'icon-alert-triangle'"
									:title="$t('Frequency.DiscardedItems.Title')"
									@click="activeDiscardedItemsPrompt = true"
								/>
								<vs-button
									v-if="visit_point_selected_delivery.length > 0"
									class="mr-2"
									type="filled"
									icon-pack="feather"
									:title="$t('UploadFiles.Download') + ' ' + $t('VisitPoints.VisitingPointsSelected')"
									:icon="'icon-download'"
									@click.prevent="activeDownload()"
								></vs-button>
								<vs-button
									v-if="maximize"
									class="mr-2"
									color="primary"
									type="filled"
									icon-pack="feather"
									:title="$t('Routing.Map.ShowMap')"
									:icon="'icon-map'"
									@click.prevent="handleMaximize"
								></vs-button>
								<vs-button
									v-if="1 === 2"
									class="mr-2"
									color="primary"
									type="filled"
									icon-pack="feather"
									icon="icon-repeat"
									:title="$t('GenerationOfRepetitions')"
									@click.prevent="generateRepeatMounted = true"
								></vs-button>
								<vs-button
									v-if="visit_point_selected_delivery.length > 0"
									class="mr-2"
									color="primary"
									type="filled"
									icon-pack="feather"
									:title="isExpandedDelivery ? $t('CollapseEverything') : $t('ExpandAll')"
									:icon="isExpandedDelivery ? 'icon-minimize-2' : 'icon-maximize-2'"
									@click.prevent="toggleAllDelivery"
								></vs-button>
								<vs-dropdown
									vs-trigger-click
									class="ml-auto cursor-pointer"
									:title="$t('Routing.Buttons.AddVisitPoint')"
								>
									<vs-button color="primary" type="filled" icon="icon-plus" icon-pack="feather" />
									<vs-dropdown-menu :style="{width: windowWidth > 620 ? '20%' : '50%'}">
										<h4 class="p-4">{{ $t("Routing.Title.VisitPoints") }}</h4>
										<vs-dropdown-item>
											<div
												class="flex items-center"
												:title="$t('MODULE_ROLE.Add') + ' ' + $t('VisitPoint')"
												@click.prevent="showSidebar()"
											>
												<feather-icon
													icon="PlusSquareIcon"
													class="inline-block mr-2 color-logo"
													svgClasses="w-5 h-5"
												/>
												<span>{{ $t("CompanyModule.Add") }}</span>
											</div>
										</vs-dropdown-item>
										<vs-dropdown-group :vs-label="$t('Select')">
											<vs-dropdown-item>
												<div
													class="flex items-center"
													:title="$t('VisitPoints.AssignVisitPointToltip')"
													@click.prevent="visitPointMounted = true"
												>
													<img
														src="@/assets/images/logo/serviroutes.svg"
														style="width: 21px; height: 21px; margin-right: 1px"
														alt=""
													/>
													<span>{{ "Serviroutes" }}</span>
												</div>
											</vs-dropdown-item>
											<vs-dropdown-item>
												<div
													class="flex items-center"
													:title="$t('VisitPoints.AssignVisitPointToltip')"
													@click.prevent="visitPointMountedDatarutas = true"
												>
													<img
														src="@/assets/images/logo/datarutas.svg"
														style="width: 17px; height: 17px; margin-right: 4px"
														alt=""
													/>
													<span>{{ "Datarutas" }}</span>
												</div>
											</vs-dropdown-item>
										</vs-dropdown-group>
										<vs-dropdown-group :vs-label="$t('Upload') + ' ' + $t('UploadFiles.File')">
											<vs-dropdown-item>
												<div
													class="flex items-center"
													@click.prevent="uploadFileMounted = true"
												>
													<feather-icon
														icon="FilePlusIcon"
														class="inline-block mr-2 color-logo"
														svgClasses="w-5 h-5"
													/>
													<span>{{ $t("Routing.Buttons.AddVisitPoint") }}</span>
												</div>
											</vs-dropdown-item>
											<vs-dropdown-item
												:disabled="visit_point_selected_delivery.length > 0 ? false : true"
											>
												<div
													class="flex items-center"
													:title="$t('UpdatingVisitPointsByUploadingFiles')"
													@click.prevent="uploadFileUpdateMounted = true"
												>
													<feather-icon
														icon="EditIcon"
														class="inline-block mr-2 color-logo"
														svgClasses="w-5 h-5"
													/>
													<span>{{ $t("VisitPoints.UpdatePointofVisit") }}</span>
												</div>
											</vs-dropdown-item>
										</vs-dropdown-group>
									</vs-dropdown-menu>
								</vs-dropdown>
							</div>
						</div>
						<div v-if="visit_point_selected_delivery.length > 0" class="vx-col w-full lg:block mt-4">
							<div class="flex flex-wrap items-center justify-end">
								<template>
									<vs-dropdown vs-trigger-click class="cursor-pointer">
										<div
											class="p-3 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
										>
											<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
											<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
										</div>
										<vs-dropdown-menu>
											<vs-dropdown-item @click="setSearchField('Identification')">
												<span>{{ $t("ResourceModule.Table.Identification") }}</span>
											</vs-dropdown-item>
											<vs-dropdown-item @click="setSearchField('GroupSearch')">
												<span>{{ $t("GroupSearch") }}</span>
											</vs-dropdown-item>
										</vs-dropdown-menu>
									</vs-dropdown>
								</template>
								<vs-input
									v-model="searchQueryDelivery"
									icon="icon-search"
									icon-pack="feather"
									class="w-full md:w-1/2"
									:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
								/>
							</div>
						</div>
						<vue-perfect-scrollbar class="scroll-area" :settings="settings">
							<ListSelectedVisitPointsItemDelivery
								ref="ListSelectedVisitPointsItemDelivery"
								:visit_point_selected_delivery="getVisitPointDeliveryList"
								:activeTabProp="activeTab"
								:markerArray="markerArrayProps"
								:searchQueryDelivery="searchQueryDelivery"
								@removeMarkerEmit="removeMarker"
								@getExpanded="getExpandedDelivery"
							></ListSelectedVisitPointsItemDelivery>
						</vue-perfect-scrollbar>
					</vs-tab>
				</vs-tabs>
			</vx-card>
		</div>
		<div id="google-map-loading" class="vx-col w-full md:w-2/5 vs-con-loading__container" v-show="!maximize">
			<vs-button
				class="btn-hiden-map"
				style="
					color: rgb(51, 49, 49);
					border-radius: 2px;
					position: absolute;
					z-index: 1;
					top: 50px;
					right: 25px;
					box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
				"
				color="white"
				type="filled"
				icon="location_off"
				:title="$t('Routing.Map.HideMap')"
				@click.prevent="handleMaximize"
			></vs-button>
			<transition name="fade">
				<OptimizationMap
					v-if="isMounted && activeTabVisitPoint"
					ref="OptimizationMap"
					:name="mapConfig.name"
					:latitude="mapConfig.latitude"
					:longitude="mapConfig.longitude"
					:zoom="mapConfig.zoom"
					:theme="mapConfig.theme"
					:calledFrom="mapConfig.calledFrom"
					:typeService="activeTab === 0 ? 'pickup' : 'delivery'"
					:visitPointList="activeTab === 0 ? visit_point_selected_pickup : visit_point_selected_delivery"
					@markerArrayEmit="getMarkerArray"
				/>
			</transition>
		</div>
		<optimization-download
			:activeDownload="isActiveDownload"
			:dataToDownload="activeTab === 0 ? visit_point_selected_pickup : visit_point_selected_delivery"
			:fieldsOptimization="activeTab === 0 ? 'pickups' : 'deliveries'"
			:textTitle="activeTab === 0 ? $t('PickupPoints') : $t('DeliveryPoints')"
			@activePopupEmit="activePopup"
		/>
		<!-- VISIT POINT LIST COMPONENT -->
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="$t('VisitPoints.ListVisitPoint') + ' Serviroutes'"
			:active.sync="visitPointMounted"
		>
			<visit-point-list
				v-if="visitPointMounted"
				ref="VisitPointList"
				class="mt-10"
				:customConfig="visitPointListConfig"
				:status_id="status_id"
			>
				<div class="is-stuck" style="background: white">
					<vx-card
						ref="filterCard"
						:title="$t('Filters')"
						class="user-list-filters mb-8"
						no-shadow
						card-border
					>
						<template slot="actions">
							<div class="form-header-inner">
								<div
									class="flex items-center"
									style="border: 1px solid #e4e4e4; padding-top: 2.5%; padding-bottom: 2.5%"
								>
									<vs-checkbox
										color="primary"
										v-model="checkboxPickup"
										class="font-bold"
										:disabled="isDisabledPickup"
										>{{ $t("PICKUP") }}</vs-checkbox
									>
									<vs-checkbox
										color="primary"
										v-model="checkboxDelivery"
										class="font-bold"
										:disabled="isDisabledDelivery"
										>{{ $t("DELIVERY") }}</vs-checkbox
									>
								</div>
								<vs-button
									:size="iconSize"
									class="ml-2"
									id="btn-locate-visit-point"
									icon-pack="feather"
									icon="icon-check"
									:title="$t('VisitPoints.Assig') + ' ' + $t('Routing.Title.Selection')"
									:disabled="getCheckedVisitPoints.length <= 0"
									@click.prevent="setAssignedVisitPoint()"
									>{{
										windowWidth > 620
											? $t("VisitPoints.Assig") + " " + $t("Routing.Title.Selection")
											: null
									}}
								</vs-button>
							</div>
						</template>
						<div class="vx-row">
							<div class="vx-col w-full md:w-1/4">
								<label class="vs-input--label">{{ $t("SearchBy") }}</label>
								<v-select
									v-model="searchField"
									:clearable="false"
									:options="searchOptions"
									name="country"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
									class="md:mb-1 mb-4"
								>
									<template v-slot:no-options="{search, searching}">
										<template v-if="searching">
											{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
										</template>
										<template v-else>
											{{ $t("NoResultsFound") }}
										</template>
									</template>
								</v-select>
							</div>
							<div class="vx-col w-full md:w-1/2">
								<div class="vx-row">
									<div class="vx-col w-full md:w-1/1">
										<tags-input
											class="w-full mt-2 md:mt-6"
											element-id="tags"
											v-model="searchQuery"
											add-tags-on-comma
											add-tags-on-blur
											:title="$t('SearchSeparatedByCommas') + '.'"
											:placeholder="$t('Teams.Form.Add') + ' ' + searchField.label"
											:typeahead="true"
											@keyup.enter="searchAssignedVisitPoint"
										></tags-input>
									</div>
								</div>
							</div>
							<div class="vx-col w-full md:w-1/4">
								<div class="flex items-center mt-2 md:mt-6">
									<vs-button
										:size="iconSize"
										:title="$t('VisitPoints.Search')"
										class="ml-2"
										icon-pack="feather"
										icon="icon-search"
										@click.prevent="searchAssignedVisitPoint"
										>{{ windowWidth > 620 ? $t("VisitPoints.Search") : null }}
									</vs-button>
									<vs-button
										:size="iconSize"
										:title="$t('Refresh')"
										class="ml-2"
										icon-pack="feather"
										icon="icon-refresh-cw"
										@click="refreshVisitPoint"
										>{{ windowWidth > 620 ? $t("Refresh") : null }}
									</vs-button>
								</div>
							</div>
						</div>
					</vx-card>
				</div>
				<vs-divider class="d-theme-border-grey-light" />
			</visit-point-list>
		</vs-popup>
		<!-- VISIT POINT LIST COMPONENT DATARUTAS-->
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="$t('VisitPoints.ListVisitPoint') + ' Datarutas'"
			:active.sync="visitPointMountedDatarutas"
		>
			<visit-point-list-datarutas
				v-if="visitPointMountedDatarutas && isDatarutasEnabled"
				ref="VisitPointListDatarutas"
				:customConfig="visitPointListConfigDatarutas"
			>
				<div class="is-stuck--datarutas" style="background: white">
					<vx-card ref="filterCard" :title="$t('Filters')" class="user-list-filters" no-shadow card-border>
						<template slot="actions">
							<div class="form-header-inner">
								<div
									class="flex items-center"
									style="border: 1px solid #e4e4e4; padding-top: 2.5%; padding-bottom: 2.5%"
								>
									<vs-checkbox
										color="primary"
										v-model="checkboxPickup"
										class="font-bold"
										:disabled="isDisabledPickup"
										>{{ $t("PICKUP") }}</vs-checkbox
									>
									<vs-checkbox
										color="primary"
										v-model="checkboxDelivery"
										class="font-bold"
										:disabled="isDisabledDelivery"
										>{{ $t("DELIVERY") }}</vs-checkbox
									>
								</div>
								<vs-button
									:size="iconSize"
									class="ml-2"
									id="btn-locate-visit-point"
									icon-pack="feather"
									icon="icon-check"
									:title="$t('VisitPoints.Assig') + ' ' + $t('Routing.Title.Selection')"
									:disabled="getCheckedVisitPointsDatarutas.length <= 0"
									@click.prevent="setAssignedVisitPoint()"
									>{{
										windowWidth > 620
											? $t("VisitPoints.Assig") + " " + $t("Routing.Title.Selection")
											: null
									}}
								</vs-button>
							</div>
						</template>
						<div class="vx-row">
							<div class="vx-col w-full md:w-1/4">
								<label class="vs-input--label">{{ $t("SearchBy") }}</label>
								<v-select
									v-model="searchField"
									:clearable="false"
									:options="searchOptions"
									name="country"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
									class="md:mb-1 mb-4"
								>
									<template v-slot:no-options="{search, searching}">
										<template v-if="searching">
											{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
										</template>
										<template v-else>
											{{ $t("NoResultsFound") }}
										</template>
									</template>
								</v-select>
							</div>
							<div class="vx-col w-full md:w-1/2">
								<div class="vx-row">
									<div class="vx-col w-full md:w-1/1">
										<tags-input
											class="w-full mt-2 md:mt-6"
											element-id="tags"
											v-model="searchQuery"
											add-tags-on-comma
											add-tags-on-blur
											:title="$t('SearchSeparatedByCommas') + '.'"
											:placeholder="$t('Teams.Form.Add') + ' ' + searchField.label"
											:typeahead="true"
											@keyup.enter="searchAssignedVisitPointDatarutas"
										></tags-input>
									</div>
								</div>
							</div>
							<div class="vx-col w-full md:w-1/4">
								<div class="flex items-center mt-2 md:mt-6">
									<vs-button
										:size="iconSize"
										:title="$t('VisitPoints.Search')"
										class="ml-2"
										icon-pack="feather"
										icon="icon-search"
										@click.prevent="searchAssignedVisitPointDatarutas"
										>{{ windowWidth > 620 ? $t("VisitPoints.Search") : null }}
									</vs-button>
									<vs-button
										:size="iconSize"
										:title="$t('Refresh')"
										class="ml-2"
										icon-pack="feather"
										icon="icon-refresh-cw"
										@click="refreshVisitPointDatarutas"
										>{{ windowWidth > 620 ? $t("Refresh") : null }}
									</vs-button>
								</div>
							</div>
						</div>
					</vx-card>
				</div>
				<vs-divider class="d-theme-border-grey-light" />
			</visit-point-list-datarutas>
			<not-authorized
				v-else
				:subTitle="$t('NotAuthorizedPage.SubtitleDatarutas')"
				:login="loginDatarutas"
			></not-authorized>
		</vs-popup>
		<!-- UPDATE UPLOAD FILE VISIT POINT -->
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="activeTab === 0 ? $t('PickUpService') : $t('DeliveryService')"
			:active.sync="uploadFileUpdateMounted"
		>
			<upload-file
				ref="uploadVisitPointUpdate"
				:typeService="this.activeTab === 0 ? 'PICKUP' : 'DELIVERY'"
				:inputFileId="'inputFileVisitPointUpdate'"
				:inputFileIcon="'MapPinIcon'"
				:typeUploadFile="'VISIT_POINT_UPLOAD'"
				:typeAction="'UPDATE'"
				:activateListUploadFile="false"
				:showUploadFileOptimization="showUploadFileOptimization"
				:showSetEquivalenceOptimization="showSetEquivalenceOptimization"
				@setUploadFileOptimization="setUploadFileOptimization"
				@setEquivalenceOptimization="setEquivalenceOptimization"
				@closePopupEmit="closePopup"
			/>
		</vs-popup>
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="activeTab === 0 ? $t('PickUpService') : $t('DeliveryService')"
			:active.sync="uploadFileMounted"
		>
			<upload-file
				ref="uploadVisitPointAdd"
				:typeService="this.activeTab === 0 ? 'PICKUP' : 'DELIVERY'"
				:inputFileId="'inputFileVisitPointAdd'"
				:inputFileIcon="'MapPinIcon'"
				:typeUploadFile="'VISIT_POINT_UPLOAD'"
				:typeAction="'ADD'"
				:activateListUploadFile="true"
				:showUploadFileOptimization="showUploadFileOptimization"
				:showSetEquivalenceOptimization="showSetEquivalenceOptimization"
				@setUploadFileOptimization="setUploadFileOptimization"
				@setEquivalenceOptimization="setEquivalenceOptimization"
				@closePopupEmit="closePopupAddUploadFile"
			/>
		</vs-popup>
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="$t('GenerationOfRepetitions')"
			:active.sync="generateRepeatMounted"
		>
			<generate-repeat
				v-if="generateRepeatMounted"
				:showPopup="generateRepeatMounted"
				:activeTabRepeat="activeTab"
				:toggleAllSelectedInformation="activeTab === 0 ? toggleAllPickup : toggleAllDelivery"
				@closePopupEmit="closePopupGenerateRepeatEmit()"
			/>
		</vs-popup>
		<vs-prompt
			class="prompt-content"
			:title="$t('Frequency.DiscardedItems.Title')"
			:active.sync="activeDiscardedItemsPrompt"
			:cancelText="$t('Routing.Title.Close')"
			:buttons-hidden="true"
			@cancel="closeDiscardedItemsPrompt"
			@close="closeDiscardedItemsPrompt"
		>
			<div class="text-left">
				<p>{{ $t("Frequency.DiscardedItems.Message") }}</p>
				<ul class="mt-2 mb-10 pl-4">
					<li v-for="(item, index) in paginatedDiscardedItems" :key="index" class="mb-2">❌ {{ item }}</li>
				</ul>
				<!-- Pagination -->
				<div v-if="showDiscardedItemsPagination" class="mt-2 mb-10 text-center">
					<vs-pagination
						:total="totalDiscardedItemsPages"
						:max="5"
						v-model="currentDiscardedItemsPage"
						@change="changeDiscardedItemsPage"
					/>
				</div>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import ListSelectedVisitPointsItemPickup from "@/components/optimization/visit-point/ListSelectedVisitPointsItemPickup.vue";
import ListSelectedVisitPointsItemDelivery from "@/components/optimization/visit-point/ListSelectedVisitPointsItemDelivery.vue";
import OptimizationMap from "../OptimizationMap.vue";
import VisitPointList from "@/components/visit-point/list/VisitPointList.vue";
import moduleCommon from "@/store/common/moduleCommon.js";
import VisitPointCreate from "./create/VisitPointCreate.vue";
import UploadFile from "@/components/optimization/upload-file/UploadFile.vue";
import VisitPointListDatarutas from "@/components/visit-point-datarutas/list/VisitPointList.vue";
import NotAuthorized from "@/components/optimization/datarutas/NotAuthorized.vue";
import moduleSessionApi from "@/store/session-api/moduleSessionApi";
import DateUtils from "@/helpers/DateUtils.js";
import {firebaseInstance as firebase} from "@/main";
import GenerateRepeat from "@/components/optimization/generate-repeat/GenerateRepeat.vue";
import OptimizationDownload from "@/components/optimization/OptimizationDownload.vue";

export default {
	name: "ListSelectedVisitPoints",
	components: {
		vSelect,
		VuePerfectScrollbar,
		ListSelectedVisitPointsItemPickup,
		ListSelectedVisitPointsItemDelivery,
		OptimizationMap,
		VisitPointList,
		VisitPointCreate,
		UploadFile,
		VisitPointListDatarutas,
		NotAuthorized,
		GenerateRepeat,
		OptimizationDownload,
	},
	props: {
		activeTabVisitPoint: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			maximize: false,
			isMounted: false,
			checkboxPickup: false,
			checkboxDelivery: false,
			isDisabledPickup: false,
			isDisabledDelivery: false,
			visitPointList: {},
			activeTab: 0,
			visitPointMounted: false,
			visitPointMountedDatarutas: false,
			uploadFileUpdateMounted: false,
			uploadFileMounted: false,
			generateRepeatMounted: false,
			status_id: [],
			searchQuery: [],
			isSidebarAddActive: false,
			markerArrayProps: {},
			searchQueryPickup: null,
			searchQueryDelivery: null,
			searchFieldShipping: "Identification",
			searchField: {value: "Identification", label: this.$t("Routing.Table.Identification")},
			showUploadFileOptimization: true,
			showSetEquivalenceOptimization: false,
			isDatarutasEnabled: false,
			isExpandedPickup: false,
			isExpandedDelivery: false,
			isActiveDownload: false,
			activeDiscardedItemsPrompt: false,
			discardedItemsList: [],
			discardedItemsPerPage: 20,
			currentDiscardedItemsPage: 1,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			settingsForm: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			mapConfig: {
				name: "optimization-map",
				latitude: 4.686699,
				longitude: -74.0837187,
				zoom: "13",
				theme: "uber",
				calledFrom: "DinamicFields",
			},
			visitPointListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: [
					"id",
					"identification",
					"demand",
					"typeService",
					"address",
					"city",
					"department",
					"status_name",
				],
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: false,
				showActions: false,
				filterHead: false,
				cellRendererAdditionalFields: false,
				CellRendererDemand: false,
				CellRendererTypeService: false,
				showPopup: true,
			},
			visitPointListConfigDatarutas: {
				rowSelection: "multiple",
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				tableOptions: false,
				showItemsPerPage: false,
				showPopup: true,
				showMaximizeBtn: true,
				showActions: true,
				cellRendererAdditionalFields: true,
				columns: ["identification", "name", "address", "city", "department", "country", "status_name"],
			},
		};
	},
	watch: {
		activeTab(val) {
			this.initMap();
			this.searchQueryPickup = null;
			this.searchQueryDelivery = null;
			this.searchFieldShipping = "Identification";
			if (val === 0) {
				this.uploadFileUpdateMounted = false;
				this.checkboxPickup = true;
				this.checkboxDelivery = false;
				this.isDisabledDelivery = false;
				this.isDisabledPickup = true;
			} else {
				this.uploadFileUpdateMounted = false;
				this.checkboxDelivery = true;
				this.checkboxPickup = false;
				this.isDisabledPickup = false;
				this.isDisabledDelivery = true;
			}
		},
		async uploadFileMounted(val) {
			if (!val) {
				await this.$refs.uploadVisitPointAdd.cancelEquivalenceEmit();
				this.$refs.uploadVisitPointAdd.cleanData();
			}
		},
		async uploadFileUpdateMounted(val) {
			if (!val) {
				await this.$refs.uploadVisitPointUpdate.cancelEquivalenceEmit();
				this.$refs.uploadVisitPointUpdate.cleanData();
			}
		},
		searchFieldSelected(val) {
			if (val) {
				this.searchQueryPickup = null;
				this.searchQueryDelivery = null;
			}
		},
	},
	computed: {
		visit_point_selected_pickup() {
			return this.$store.state.moduleOptimization.standardInputList["pickups"] === undefined ||
				this.$store.state.moduleOptimization.standardInputList["pickups"] === "" ||
				this.$store.state.moduleOptimization.standardInputList["pickups"] === null
				? []
				: this.$store.state.moduleOptimization.standardInputList["pickups"];
		},
		visit_point_selected_delivery() {
			return this.$store.state.moduleOptimization.standardInputList["deliveries"] === undefined ||
				this.$store.state.moduleOptimization.standardInputList["deliveries"] === "" ||
				this.$store.state.moduleOptimization.standardInputList["deliveries"] === null
				? []
				: this.$store.state.moduleOptimization.standardInputList["deliveries"];
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		searchOptions() {
			return [
				{value: "Identification", label: this.$t("Routing.Table.Identification")},
				{value: "Address", label: this.$t("Address")},
				{value: "City", label: this.$t("City")},
				{value: "Department", label: this.$t("Divipola.Department")},
			];
		},
		getCheckedVisitPoints() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoits === undefined ||
				this.$store.state.moduleVisitPoint.checkedVisitPoits === "" ||
				this.$store.state.moduleVisitPoint.checkedVisitPoits === null
				? []
				: this.$store.state.moduleVisitPoint.checkedVisitPoits;
		},
		getCheckedVisitPointsDatarutas() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoitsDatarutas === undefined ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsDatarutas === "" ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsDatarutas === null
				? []
				: this.$store.state.moduleVisitPoint.checkedVisitPoitsDatarutas;
		},
		getVisitPointPickupList() {
			return this.getFilteredVisitPointList(
				this.visit_point_selected_pickup,
				this.searchQueryPickup,
				this.searchFieldShipping
			);
		},
		getVisitPointDeliveryList() {
			return this.getFilteredVisitPointList(
				this.visit_point_selected_delivery,
				this.searchQueryDelivery,
				this.searchFieldShipping
			);
		},
		searchSelected() {
			return this.$t(`${this.searchFieldShipping}`);
		},
		// Pagination computed properties for discarded items
		paginatedDiscardedItems() {
			const startIndex = (this.currentDiscardedItemsPage - 1) * this.discardedItemsPerPage;
			const endIndex = startIndex + this.discardedItemsPerPage;
			return this.discardedItemsList.slice(startIndex, endIndex);
		},
		totalDiscardedItemsPages() {
			return Math.ceil(this.discardedItemsList.length / this.discardedItemsPerPage);
		},
		showDiscardedItemsPagination() {
			return this.discardedItemsList.length > this.discardedItemsPerPage;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		handleMaximize() {
			this.maximize = !this.maximize;
		},
		showSidebar() {
			this.isSidebarAddActive = true;
		},
		closeSidebar() {
			this.isSidebarAddActive = false;
		},
		addMarker(visitPoint) {
			this.$refs.OptimizationMap.addSomeMarkers([visitPoint]);
		},
		removeMarker(marker) {
			this.$refs.OptimizationMap.removeMarker(marker);
		},
		startBounceAnimation(id) {
			this.$refs.OptimizationMap.startBounceAnimation(id);
		},
		closeAnimation(id) {
			this.$refs.OptimizationMap.closeAnimation(id);
		},
		initMap() {
			if (this.$refs.OptimizationMap && typeof this.$refs.OptimizationMap.initMap === "function") {
				this.$refs.OptimizationMap.initMap();
			}
		},
		searchAssignedVisitPoint() {
			this.$refs.VisitPointList.searchAssignedVisitPoint(this.searchField.value, this.searchQuery, 1);
		},
		searchAssignedVisitPointDatarutas() {
			this.$refs.VisitPointListDatarutas.searchAssignedVisitPoint(this.searchField.value, this.searchQuery, 1);
		},
		refreshVisitPoint() {
			this.$refs.VisitPointList.refreshVisitPoint();
			this.searchQuery = [];
			this.searchField = {value: "Identification", label: this.$t("Routing.Table.Identification")};
		},
		refreshVisitPointDatarutas() {
			this.$refs.VisitPointListDatarutas.refreshVisitPoint();
			this.searchQuery = [];
			this.searchField = {value: "Identification", label: this.$t("Routing.Table.Identification")};
		},
		setAssignedVisitPoint() {
			let pickups = {};
			if (this.getCheckedVisitPoints.length > 0) {
				pickups = {serviroutes_visit_point_ids: this.getCheckedVisitPoints.map(({id}) => id)};
			} else if (this.getCheckedVisitPointsDatarutas.length > 0) {
				pickups = {datarutas_visit_point_ids: this.getCheckedVisitPointsDatarutas.map(({id}) => id)};
			}
			let deliveries = {};
			if (this.getCheckedVisitPoints.length > 0) {
				deliveries = {serviroutes_visit_point_ids: this.getCheckedVisitPoints.map(({id}) => id)};
			} else if (this.getCheckedVisitPointsDatarutas.length > 0) {
				deliveries = {datarutas_visit_point_ids: this.getCheckedVisitPointsDatarutas.map(({id}) => id)};
			}
			const payload = {
				pickups,
				deliveries,
				global_config: {
					init_date: DateUtils.toDefaultDateTime(
						this.$store.state.moduleOptimization.standardInputList["global_config"].init_date,
						"YYYY-MM-DD"
					),
					end_date: DateUtils.toDefaultDateTime(
						this.$store.state.moduleOptimization.standardInputList["global_config"].end_date,
						"YYYY-MM-DD"
					),
					init_hour: this.$store.state.moduleOptimization.standardInputList["global_config"].init_hour,
					end_hour: this.$store.state.moduleOptimization.standardInputList["global_config"].end_hour,
				},
			};
			this.$store
				.dispatch("moduleOptimization/generateStandardInputFilter", payload)
				.then((res) => {
					// Check if there are discarded items due to frequencies
					if (
						res.data &&
						res.data.warnings &&
						Array.isArray(res.data.warnings) &&
						res.data.warnings.length > 0
					) {
						const discardedItems = res.data.warnings.filter(
							(item) => typeof item === "string" && item.includes("discarded due to frequencies")
						);

						if (discardedItems.length > 0) {
							this.showDiscardedItemsPrompt(discardedItems);
						}
					}
					if (this.checkboxPickup) {
						this.$store.commit(
							"moduleOptimization/SET_VISIT_POINT_STANDARD_INPUT_PICKUP",
							res.data["pickups"]
						);
						this.$refs.OptimizationMap.addSomeMarkers(res.data["pickups"]);
					}
					if (this.checkboxDelivery) {
						this.$store.commit(
							"moduleOptimization/SET_VISIT_POINT_STANDARD_INPUT_DELIVERY",
							res.data["deliveries"]
						);
						this.$refs.OptimizationMap.addSomeMarkers(res.data["deliveries"]);
					}
					if (this.activeTab === 0 && this.isExpandedPickup) {
						this.toggleAllPickup();
					} else if (this.activeTab === 1 && this.isExpandedDelivery) {
						this.toggleAllDelivery();
					}
					this.visitPointMounted = false;
					this.visitPointMountedDatarutas = false;
					this.searchQuery = [];
					return res;
				})
				.catch((err) => {
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
						time: 7000,
					});
					console.error(err);
					return err;
				});
		},
		addVisitPoint() {
			this.$store.commit("moduleOptimization/SET_OPTIMIZATION_GROUP_SIDEBAR_ACTIVE", true);
		},
		getMarkerArray(val) {
			this.markerArrayProps = val;
		},
		closePopup() {
			this.uploadFileUpdateMounted = false;
		},
		closePopupAddUploadFile() {
			this.uploadFileMounted = false;
		},
		setUploadFileOptimization(val) {
			this.showUploadFileOptimization = val;
		},
		setEquivalenceOptimization(val) {
			this.showSetEquivalenceOptimization = val;
		},
		async getSessionApiByToken() {
			try {
				const token = localStorage.getItem("accessToken");
				const response = await this.$store.dispatch("moduleSessionApi/getSessionApiByToken", token);
				if (response.data.hasOwnProperty("datarutas_company_id")) {
					this.isDatarutasEnabled = true;
				}
			} catch (error) {
				console.error(error);
			}
		},
		async loginDatarutas() {
			await firebase.auth().signInAnonymously();
			this.openLoadingInDiv();
			this.$store
				.dispatch("moduleOptimization/datarutasLogin")
				.then((response) => {
					this.$vs.loading.close("#div-with-loading > .con-vs-loading");
					if (response.status === 200 && response.data.hasOwnProperty("datarutas_company_id")) {
						this.isDatarutasEnabled = true;
						this.$vs.notify({
							color: "success",
							title: this.$t("Login.Login"),
							text: this.$t("Login.YouHaveSuccessfullyLoggedInToDatarutas"),
							time: 9000,
						});
					} else {
						this.$vs.notify({
							color: "danger",
							title: this.$t("Login.Login") + " " + "Datarutas",
							text: this.$t("Login.CouldNotConnectToDatarutas"),
							time: 9000,
						});
					}
				})
				.catch((err) => {
					this.$vs.loading.close("#div-with-loading > .con-vs-loading");
					this.$vs.notify({
						color: "danger",
						title: this.$t("Login.Login") + " " + "Datarutas",
						text: this.$t("Login.CouldNotConnectToDatarutas"),
						time: 9000,
					});
					console.error(err);
				});
		},
		openLoadingInDiv() {
			this.$vs.loading({
				container: "#div-with-loading",
				scale: 0.6,
				text: this.$t("Login.ConnectingWithDatarutas"),
				textAfter: true,
				type: "point",
				background: "rgba(255, 255, 255, .9)",
			});
		},
		setSearchField(val) {
			this.searchFieldShipping = val;
		},
		// Metodo auxiliar para agrupar elementos por 'original_identification'
		groupByOriginalIdentification(items) {
			return items.reduce((acc, item) => {
				const key = item.original_identification;
				if (!acc[key]) {
					acc[key] = [];
				}
				acc[key].push(item);
				return acc;
			}, {});
		},
		// Método generalizado para búsqueda y filtradogetFilteredVisitPointList(items, searchQuery, searchField) {
		getFilteredVisitPointList(items, searchQuery, searchField) {
			const groupedItems = this.groupByOriginalIdentification(items);
			if (!searchQuery || searchQuery.trim().length === 0) {
				return Object.entries(groupedItems);
			}
			const filteredList = this.filterVisitPoints(groupedItems, searchQuery, searchField);
			if (filteredList.length > 0) {
				this.expandRelevantTabs();
			}
			return filteredList;
		},
		filterVisitPoints(groupedItems, searchQuery, searchField) {
			return Object.entries(groupedItems)
				.map(([key, items]) => {
					return this.filterItemsByField(key, items, searchQuery, searchField);
				})
				.filter(Boolean);
		},
		filterItemsByField(key, items, searchQuery, searchField) {
			if (searchField === "Identification") {
				const filteredItems = items.filter((point) =>
					point.identification.toLowerCase().includes(searchQuery.toLowerCase())
				);
				return filteredItems.length ? [key, filteredItems] : null;
			} else {
				return key.toString().toLowerCase().includes(searchQuery.toLowerCase()) ? [key, items] : null;
			}
		},
		expandRelevantTabs() {
			if (this.activeTab === 0 && !this.isExpandedPickup) {
				this.toggleAllPickup();
			} else if (this.activeTab === 1 && !this.isExpandedDelivery) {
				this.toggleAllDelivery();
			}
		},
		toggleAllPickup() {
			this.$refs.ListSelectedVisitPointsItemPickup.toggleAll();
		},
		toggleAllDelivery() {
			this.$refs.ListSelectedVisitPointsItemDelivery.toggleAll();
		},
		getExpandedPickup(val) {
			this.isExpandedPickup = val;
		},
		getExpandedDelivery(val) {
			this.isExpandedDelivery = val;
		},
		closePopupGenerateRepeatEmit() {
			this.generateRepeatMounted = false;
		},
		activeDownload() {
			this.isActiveDownload = true;
		},
		activePopup(val) {
			this.isActiveDownload = val;
		},
		showDiscardedItemsPrompt(discardedItems) {
			// Parse and translate the discarded items
			const translatedItems = discardedItems.map((item) => {
				// Parse the item string: "TYPE identifier, discarded due to frequencies."
				const parts = item.split(",");
				if (parts.length >= 2) {
					const typeAndIdentifier = parts[0].trim();
					// Split type and identifier
					const spaceIndex = typeAndIdentifier.indexOf(" ");
					if (spaceIndex !== -1) {
						const type = typeAndIdentifier.substring(0, spaceIndex).trim();
						const identifier = typeAndIdentifier.substring(spaceIndex + 1).trim();
						// Translate the type
						let translatedType = type;
						if (type === "PICKUP") {
							translatedType = this.$t("Frequency.DiscardedItems.Pickup");
						} else if (type === "DELIVERY") {
							translatedType = this.$t("Frequency.DiscardedItems.Delivery");
						} else if (type === "VEHICLE") {
							translatedType = this.$t("Frequency.DiscardedItems.Vehicle");
						}
						return `${translatedType} ${identifier}`;
					}
				}
				return item; // Return original if parsing fails
			});

			// Store the translated items and activate the prompt
			this.discardedItemsList = translatedItems;
			this.currentDiscardedItemsPage = 1; // Reset to first page
			this.activeDiscardedItemsPrompt = true;
		},
		// Pagination methods for discarded items
		changeDiscardedItemsPage(page) {
			if (page >= 1 && page <= this.totalDiscardedItemsPages) {
				this.currentDiscardedItemsPage = page;
			}
		},
		closeDiscardedItemsPrompt() {
			this.activeDiscardedItemsPrompt = false;
			this.currentDiscardedItemsPage = 1;
		},
	},
	mounted() {
		this.isMounted = true;
		if (this.activeTab === 0) {
			this.checkboxPickup = true;
			this.checkboxDelivery = false;
			this.isDisabledDelivery = false;
			this.isDisabledPickup = true;
		} else {
			this.checkboxDelivery = true;
			this.checkboxPickup = false;
			this.isDisabledPickup = false;
			this.isDisabledDelivery = true;
		}
		this.getSessionApiByToken();
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleSessionApi.isRegistered) {
			this.$store.registerModule("moduleSessionApi", moduleSessionApi);
			moduleSessionApi.isRegistered = true;
		}
		if (this.visit_point_selected_delivery.length > 0 && this.visit_point_selected_pickup.length === 0) {
			this.activeTab = 1;
		}
		this.$store
			.dispatch("moduleCommon/fetchDataSelectVisitPoint")
			.then((res) => {
				this.$emit("initMapOptimizationEmit", this.$refs.OptimizationMap);
				this.initMap();
				this.status_id = res.data.status.filter((st) => st.name === "ACTIVE").map(({id}) => id);
			})
			.catch((error) => {
				console.error(error);
			});
	},
};
</script>

<style lang="scss" scoped>
#content-router-selection {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 685px;
	max-height: 700px;
}
.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 50000;
	}

	::v-deep .vs-sidebar {
		z-index: 50000;
		width: 10000px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
.is-stuck {
	position: fixed;
	top: 52px;
	inset-inline-start: 0;
	margin-inline-start: 30px;
	width: calc(100% - 80px);
	z-index: 14;
}
.form-header-inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.is-stuck--datarutas {
	position: fixed;
	top: 52px;
	inset-inline-start: 0;
	margin-inline-start: 30px;
	width: calc(100% - 60px);
	z-index: 14;
}
.color-logo {
	color: rgba(35, 39, 133, 1);
}
</style>
